
module.run(function($rootScope, $state, $location) {

    $rootScope.$on('$stateChangeError',
    function(event, toState, toParams, fromState, fromParams, rejection) {
        var errorData = {
                model: rejection.model,
                permission: rejection.permission,
                fromState: fromState.name,
                fromParams: fromParams,
            };

        if (rejection.instead) {
            $state.go(rejection.instead, toParams, {relative: toState});
        } else if (rejection.reason === 'unauthorized') {
            $state.go('error', {statusCode: 403, data: errorData});
        } else if (rejection.reason === 'notfound') {
            $state.go('error', {statusCode: 404, data: errorData});
        } else {
            console.log('throw');
            throw rejection;
        }
    });
});